import { useEffect } from "react";

import { useParams, useNavigate } from "react-router-dom";

import { useAppDispatch } from "../redux/hooks";
import { backdrop, message, clear } from "../redux/app.slice";

export const ClearComponent = () => {
  const { timestamp } = useParams();
  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(backdrop(true));
    if (timestamp) {
      const timestamp_now = new Date();
      const timestamp_date = `${timestamp_now.getFullYear()}${
        timestamp_now.getMonth() + 1
      }${timestamp_now.getDate()}`;
      if (timestamp_date === timestamp) {
        dispatch(clear());
        dispatch(
          message({
            open: true,
            message: "Cache cleared successfully",
            severity: "success",
          })
        );
      } else
        dispatch(
          message({ open: true, message: "Invalid link", severity: "error" })
        );
    } else
      dispatch(
        message({ open: true, message: "Invalid link", severity: "error" })
      );
    dispatch(backdrop(false));
    navigate("/");
  }, [dispatch, timestamp, navigate]);

  return <>Clearing cache...</>;
};
